import { getResolvedCustomerName } from '../config/environment';
import { getCustomerFromCurrentHostname } from './customerFromHostname';
import { getSelectedCustomer } from './selectedCustomer';

export function getDisplayCustomerName() {
  const fromHost = getCustomerFromCurrentHostname();
  if (fromHost?.name) {
    return fromHost.name;
  }

  const selected = getSelectedCustomer();

  if (selected?.name) {
    return selected.name;
  }

  const resolvedName = getResolvedCustomerName();
  if (resolvedName) {
    return resolvedName;
  }

  return 'din kommune';
}
